import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SelectUserComponent } from './select-user.component';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { SharedModule } from '../../shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        SharedModule
    ],
    declarations: [
        SelectUserComponent
    ],
    exports: [
        SelectUserComponent
    ]
})

export class SelectUserModule { }
